export const AppEvents = {
    previsualizarPDF: 'previsualizarPDF',
    actualizarUltimaAccion: 'actualizarUltimaAccion',
    actualizarUltimaAccionIndividual: 'actualizarUltimaAccionIndividual',

    actualizarColectivo: 'actualizarColectivo',
};
